import { FC } from 'react';

import homecook_logo from '../../assets/img/homecook_logo.png';
import { ReactComponent as InstagramIcon } from '../../icons/InstagramIcon.svg';
import { PARTNER_LINKS } from './partnerContent';
import config from '../../config';

const PRODUCT_LINKS = [
  { label: 'Resource Pantry', href: `${config.webUrl}` },
  { label: 'Partner Dashboard', href: `/` },
  { label: 'Compliance Readiness Tool', href: `${config.landingUrl}/compliance` },
  { label: 'Pawdit', href: `${config.landingUrl}/pawdit` },
];

const COMPANY_LINKS = [
  { label: 'Resource Providers', href: PARTNER_LINKS.resourceProviders },
  { label: 'Food Entrepreneurs', href: PARTNER_LINKS.foodEntrepreneurs },
  { label: 'FAQs', href: PARTNER_LINKS.faq },
  { label: 'Contact us', href: PARTNER_LINKS.contact },
];

const LEGAL_LINKS = [
  { label: 'Terms of Service', href: PARTNER_LINKS.terms },
  { label: 'Privacy Policy', href: PARTNER_LINKS.privacy },
  { label: 'Disclaimer', href: PARTNER_LINKS.disclaimer },
  { label: 'EULA', href: PARTNER_LINKS.eula },
];

type FooterColumnProps = {
  heading: string;
  links: { label: string; href: string }[];
};

const FooterColumn: FC<FooterColumnProps> = ({ heading, links }) => (
  <div>
    <h4 className="font-raleway text-[15px] font-semibold text-white">{heading}</h4>
    <ul className="mt-4 space-y-3">
      {links.map((link) => (
        <li key={link.label}>
          <a
            href={link.href}
            target={link.href.startsWith('mailto:') ? undefined : '_blank'}
            rel="noreferrer"
            className="font-open-sans text-[14px] text-white/70 transition-colors hover:text-primary-400"
          >
            {link.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

/** Logged-out footer with product, company, legal, and social links. */
export const UnauthFooter: FC = () => (
  <footer className="bg-white px-4 pb-4 lg:px-12">
    <div className="mx-auto w-full max-w-[1450px] rounded-t-3xl bg-primaryDark-0 px-6 py-12 lg:px-14">
      <div className="grid gap-10 lg:grid-cols-[1.3fr_1fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-2">
            <img src={homecook_logo} alt="HomeCook" className="h-9 w-9 object-contain" />
            <span className="font-raleway text-[20px] font-semibold text-white">HomeCook App</span>
          </div>
          <p className="mt-3 max-w-[300px] font-open-sans text-[14px] leading-relaxed text-white/70">
            Powering food entrepreneurs to grow, while hosting the resource providers that support them.
          </p>
          <a
            href={PARTNER_LINKS.instagram}
            target="_blank"
            rel="noreferrer"
            className="mt-5 inline-flex items-center gap-2 font-open-sans text-[14px] text-white/70 transition-colors hover:text-primary-400"
          >
            <InstagramIcon className="h-5 w-5" aria-hidden />
            Instagram
          </a>
        </div>

        <FooterColumn heading="Products" links={PRODUCT_LINKS} />
        <FooterColumn heading="Company" links={COMPANY_LINKS} />
        <FooterColumn heading="Legal" links={LEGAL_LINKS} />
      </div>

      <div className="mt-10 flex flex-col gap-3 border-t border-white/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-open-sans text-[13px] text-white/60">© {new Date().getFullYear()} HomeCook LLC. All rights reserved.</p>
        {/* <p className="font-open-sans text-[13px] text-white/60">
          By signing in you agree to our{' '}
          <a
            href={PARTNER_LINKS.terms}
            target="_blank"
            rel="noreferrer"
            className="font-semibold text-white underline decoration-primary-400 decoration-2 underline-offset-2 hover:text-primary-400"
          >
            Terms of Service
          </a>{' '}
          and{' '}
          <a
            href={PARTNER_LINKS.privacy}
            target="_blank"
            rel="noreferrer"
            className="font-semibold text-white underline decoration-primary-400 decoration-2 underline-offset-2 hover:text-primary-400"
          >
            Privacy Policy
          </a>
          .
        </p> */}
      </div>
    </div>
  </footer>
);

export default UnauthFooter;
